import { useHistory } from 'react-router-dom'

import { store } from '../stores'
import useInterval from './useInterval'
import { isAfterEventBusinessDate } from '../utils/businessHours'
import { getCurrentEvent } from '../selectors/events'
import { getActiveAttendantId } from '../selectors/attendant'
import { logout } from '../actions/attendant'

const SECONDS = 5000

const useWatchBusinessHours = () => {
  const history = useHistory()

  useInterval(() => {
    const state = store.getState()
    const event = getCurrentEvent(state)
    const activeAttendantId = getActiveAttendantId(state)

    if (activeAttendantId && event?.startTime && isAfterEventBusinessDate(event)) {
      store.dispatch(logout())
      history.replace('/user-login')
    }
  }, SECONDS)
}

export default useWatchBusinessHours
